import { BrowserMultiFormatReader } from "@zxing/library";
import { useEffect, useRef } from "react";
import React from "react";
export const QrCodeScanner = (props) => {
    const videoRef = useRef(null);
    const reader = useRef(new BrowserMultiFormatReader());
    useEffect(() => {
        if (!videoRef.current)
            return;
        reader.current.decodeFromConstraints({
            audio: false,
            video: {
                facingMode: props.facingMode || "environment",
            },
        }, videoRef.current, (result, error) => {
            if (result)
                props.onResult(result);
            if (error && props.Errors != null)
                props.Errors(error);
        });
        return () => {
            reader.current.reset();
        };
    }, [videoRef]);
    return (React.createElement("div", null,
        React.createElement("video", { ref: videoRef })));
};
